import { useSelector } from "react-redux";
import trans from "..";
export const MergedKeyToRoute = {
  // Tracking keys
  dashboard: "/dashboard",
  dashboardqaqc: "/dashboard/qa",
  dashboardfs: "/dashboard/fsm",
  dashboards: "/dashboard/consultant",
  "live-tracking": "/livetracking",
  geofences: "/geofences",
  allreports: "/reports",
  historical: "/historical",
  groups: "/groups",
  notifications: "/notifications/all",
  "notifications.configuration": "/notifications/configuration",
  "fms.vehicles": "/fleetmanagement/vehicles",
  "fms.drivers": "/fleetmanagement/drivers",

  "setup.user-roles": "/setup/roles&permissions",
  "setup.user-rolesfs": "/setup/roles&permissionsFS",
  "setup.user-rolesqaqc": "/setup/roles&permissionsQAQC",

  "setup.account": "/setup/account",
  "live-streaming": "/streaming/live",
  playback: "/streaming/playback",
  "mod live-streaming": "/mod-streaming",
  "mod playback": "/mod-playback",
  "11-1": "/maintenance/maintenanceSchedule",
  "maintenance.regular": "/maintenance",
  "regular-maintenance": "/maintenance",
  "11-3": "/maintenance/maintenanceRequests",
  "11-4": "/maintenance/maintenanceOrders",
  maintenance: "/maintenance",

  // FSM keys (added/merged)
  forms: "/forms/all",
  // "forms.formbuilder": "/forms/formbuilder",
  "form-submissions": "/forms/submission",
  "inspection-request": "/IR",
  submittals: "/Submittals",
  task: "/tasks/tasks-board",
  "task-heatmap": "/tasks/heatmap",
  "recurring-planner": "/tasks/recurring-planners",
  requests: "/requests",

  11: "/ir-history",
  "snag-list": "/snag-list",
  "near-miss": "/near-miss",
  "snag-report": "/snag-report",
  "reports.qaqc.snagreport": "/snag-report",
  poi: "/point-of-interest", // FSM POIs key
  "setup.project-setup": "/setup/project-setup",
  "setup.companies": "/setup/companies",
  "offline-configuration": "/setup/offline-setup",
  "offline-requests": "/offline-requests",
  "setup.teams": "/setup/teams",
};

export const MergedSidebar = [
  {
    label: trans("Dashboard"),
    key: "dashboard",
    icon: (
      <img
        src={`${process.env.PUBLIC_URL}/assets/New/Sidebar/Dashboard.svg`}
        alt="Dashboard"
      />
    ),
  },
  {
    label: trans("live tracking"),
    key: "live-tracking",
    icon: (
      <img
        src={`${process.env.PUBLIC_URL}/assets/New/Sidebar/LiveTracking.svg`}
        alt="Livetracking"
      />
    ),
  },
  {
    label: trans("Geofences"),
    key: "geofences",
    icon: (
      <img
        src={`${process.env.PUBLIC_URL}/assets/New/Sidebar/Geofences.svg`}
        alt="Geofences"
      />
    ),
  },
  {
    label: trans("historical"),
    key: "historical",
    icon: (
      <img
        src={`${process.env.PUBLIC_URL}/assets/New/Sidebar/Historical.svg`}
        alt="Historical"
      />
    ),
  },
  {
    label: trans("Groups"),
    key: "groups",
    icon: (
      <img
        src={`${process.env.PUBLIC_URL}/assets/New/Sidebar/Groups.svg`}
        alt="Groups"
      />
    ),
  },
  {
    label: trans("fleet management"),
    key: "fms",
    icon: (
      <img
        src={`${process.env.PUBLIC_URL}/assets/New/Sidebar/FleetManagement.svg`}
        alt="FleetManagement"
      />
    ),
    children: [
      {
        label: trans("Vehicles"),
        key: "fms.vehicles",
      },
      {
        label: trans("drivers"),
        key: "fms.drivers",
      },
    ],
  },
  {
    label: trans("notifications"),
    key: "notifications",
    icon: (
      <img
        src={`${process.env.PUBLIC_URL}/assets/New/Sidebar/Notification.svg`}
        alt="Notification"
      />
    ),
    children: [
      {
        label: trans("notifications"),
        key: "notifications",
      },
      {
        label: trans("configuration"),
        key: "notifications.configuration",
      },
    ],
  },
  {
    label: trans("reports"),
    key: "allreports",
    icon: (
      <img
        src={`${process.env.PUBLIC_URL}/assets/New/Sidebar/Reports.svg`}
        alt="Reports"
      />
    ),
  },
  {
    label: trans("Surveillance"),
    key: "survillience",
    icon: (
      <img src={`${process.env.PUBLIC_URL}/assets/camera.svg`} alt="camera" />
    ),
    children: [
      {
        label: trans("Live Stream"),
        key: "live-streaming",
      },
      {
        label: trans("Playback"),
        key: "playback",
      },
      {
        label: trans("Streaming"),
        key: "mod live-streaming",
      },
      {
        label: trans("Playback"),
        key: "mod playback",
      },
    ],
  },
  {
    label: trans("Regular Maintenance"),
    key: "regular-maintenance",
    icon: (
      <img
        src={`${process.env.PUBLIC_URL}/assets/dark/maintenance.svg`}
        alt="maintenance"
      />
    ),
  },
  //   {
  //     label: trans("Maintenance"),
  //     key: "maintenance.regular",
  //     icon: (
  //       <img
  //         src={`${process.env.PUBLIC_URL}/assets/dark/maintenance.svg`}
  //         alt="maintenance"
  //       />
  //     ),
  //     children: [
  //       {
  //         label: trans("Maintenance Schedules"),
  //         key: "11-1",
  //       },
  //       {
  //         label: trans("Regular Maintenance"),
  //         key: "maintenance.regular",
  //       },
  //       {
  //         label: trans("Maintenance Requests"),
  //         key: "11-3",
  //       },
  //       {
  //         label: trans("Work Orders"),
  //         key: "11-4",
  //       },
  //     ],
  //   },
  {
    label: trans("POIs"),
    key: "poi",
    icon: (
      <img
        src={`${process.env.PUBLIC_URL}/assets/New/Sidebar/POIs.svg`}
        alt="POIs"
      />
    ),
  },
  {
    label: trans("Forms"),
    key: "forms",
    icon: (
      <img
        src={`${process.env.PUBLIC_URL}/assets/New/Sidebar/Forms.svg`}
        alt="Forms"
      />
    ),
    children: [
      {
        label: trans("Forms"),
        key: "forms",
      },
      // {
      // 	label: trans("Form Builder"),
      // 	key: "forms.formbuilder",
      // },
      {
        label: trans("Form Submission"),
        key: "form-submissions",
      },
    ],
  },
  {
    label: trans("Near Miss"),
    key: "near-miss",
    icon: (
      <img
        src={`${process.env.PUBLIC_URL}/assets/New/Sidebar/Forms.svg`}
        alt="Near Miss"
      />
    ),
  },
  {
    label: trans("requests"),
    key: "requests",
    icon: (
      <img
        src={`${process.env.PUBLIC_URL}/assets/New/Sidebar/Requests.svg`}
        alt="requests"
      />
    ),
  },
  {
    label: trans("Field Tasks"),
    key: "task",
    icon: (
      <img
        src={`${process.env.PUBLIC_URL}/assets/New/Sidebar/FieldService.svg`}
        alt="fieldservice"
      />
    ),
    children: [
      {
        label: trans("Tasks"),
        key: "task",
      },
      {
        label: trans("Tasks Heatmap"),
        key: "task-heatmap",
      },
      {
        label: trans("Recurring Planners"),
        key: "recurring-planner",
      },
    ],
  },
  {
    label: trans("Inspection Request"),
    key: "inspection-request",
    icon: (
      <img
        src={`${process.env.PUBLIC_URL}/assets/New/Sidebar/ir.svg`}
        alt="Inspection Request"
      />
    ),
    offline: true,
  },
  {
    label: trans("Submittals"),
    key: "submittals",
    icon: (
      <img
        src={`${process.env.PUBLIC_URL}/assets/New/Sidebar/submittal.svg`}
        alt="Submittals"
      />
    ),
  },
  {
    label: trans("Snag"),
    key: "snag",
    icon: (
      <img
        src={`${process.env.PUBLIC_URL}/assets/New/Sidebar/snag.svg`}
        alt="Snag"
      />
    ),
    offline: true,
    children: [
      {
        label: trans("Snag List"),
        key: "snag-list",
        offline: true,
      },
      {
        label: trans("Snag Report"),
        // Keyed by the backend permission `name` (resource SNAGREPORT) so it
        // matches via permissionNames in both NewMainlayout (desktop) and the
        // mobile drawer. NOTE: an explicitly-matched child suppresses siblings
        // that rely on the parent's all-children fallback, so "snag-list" is
        // added as a derived alias to permissionNames in both layouts to keep
        // it visible next to this child.
        key: "reports.qaqc.snagreport",
      },
    ],
  },
  {
    label: trans("Offline Requests"),
    key: "offline-requests",
    icon: (
      <img
        src={`${process.env.PUBLIC_URL}/assets/New/Sidebar/Settings.svg`}
        alt="offlinerequests"
      />
    ),
  },
  {
    label: trans("setup"),
    key: "setup",
    icon: (
      <img
        src={`${process.env.PUBLIC_URL}/assets/New/Sidebar/Adminstration.svg`}
        alt="Setup"
      />
    ),
    offline: true,
    children: [
      {
        label: trans("users & roles"),
        key: "setup.user-roles",
      },
      {
        label: trans("users & roles"),
        key: "setup.user-rolesfs",
      },
      {
        label: trans("users & roles"),
        key: "setup.user-rolesqaqc",
      },
      {
        label: trans("account"),
        key: "setup.account",
      },
      {
        label: trans("project setup"),
        key: "setup.project-setup",
      },
      {
        label: trans("companies"),
        key: "setup.companies",
      },
      {
        label: trans("teams"),
        key: "setup.teams",
      },
      {
        label: trans("Offline Model"),
        key: "offline-configuration",
        offline: true,
      },
    ],
  },
];
